<template>
        <m-assembly-table ref='pageForm'
                        :formData='formData'
                        :columns='columns'
                        :data='tableData'
                        :tableButtons='tableButtons'
                        :loading='loading'
                        :currentPage='settings.currentPage'
                        :pageSize='settings.pageSize'
                        :total='settings.total'
                        :settings='settings'
                        @onSubmit='onSubmit'
                        @onPageSizeChange='onPageSizeChange'
                        @onCurrentPageChange='onPageChange'
        >
        <div slot="button" style="margin-bottom:10px;">
            <Button style="margin-left:10px;" type="primary" size="small" @click="exportExcel" :loading="loading">{{$t('DeliveryOrderQuery.t6')}}</Button>
        </div>
        </m-assembly-table>
</template>
<script>
import axios from 'axios';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
export default {
    name: 'deliveryNoticeDetailInquery',
    components: { 
        mAssemblyTable 
    },
    data () {
        return {
            formData: {
                row: 4,
                items: [
                    {
                        value: '',
                        field: 'orgCode',
                        disabled: false,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('deliveryNoticeConfirm.t38') // 库存组织
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('deliveryNoticeConfirm.t1')
                    },
                    {
                        value: '',
                        field: 'notifyNameStatus',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change() {
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('deliveryNoticeDetailInquery.t2')
                    },
                    {
                        value: '',
                        field: 'needByDateStart',
                        layout: {
                            row: 1,
                            span: 8,
                            offset: 0
                        },
                        style: 'width:100%',
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd'
                        },
                        type: 'datePicker',
                        title: this.$t('deliveryNoticeConfirm.t3'), // 需求日期
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'needByDateEnd',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 2
                        },
                        style: 'width:100%',
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'itemCodeStart', // 物料编码
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('DeliveryOrderQuery.t26'),
                    },
                    {
                        value: '',
                        title: this.$t('DeliveryOrderQuery.t27'),
                        field: 'itemCodeEnd',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    },
                    {
                        value: '',
                        field: 'sourceTypeCode',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        methods: {
                            change() {
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('deliveryNoticeDetailInquery.t4') // 送货通知类型
                    },
                    {
                        value: '',
                        field: 'releasedDateStart',
                        layout: {
                            row: 3,
                            span: 8,
                            offset: 0
                        },
                        style: 'width:100%',
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00'
                        },
                        type: 'datePicker',
                        title: this.$t('deliveryNoticeConfirm.t4'), // 通知下达日期
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'releasedDateEnd',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 3
                        },
                        style: 'width:100%',
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'wipentityNames',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('deliveryNoticeConfirm.t5') // 作业号
                    },
                    {
                        value: '',
                        field: 'confirmDateStart',
                        layout: {
                            row: 3,
                            span: 8,
                            offset: 0
                        },
                        style: 'width:100%',
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00'
                        },
                        type: 'datePicker',
                        title: this.$t('deliveryNoticeDetailInquery.t3'), // 通知确认日期
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'confirmDateEnd',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 3
                        },
                        style: 'width:100%',
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'scheduledStartDateStart',
                        validators: {
                        },
                        layout: {
                            row: 3,
                            span: 8,
                            offset: 0
                        },
                        style: 'width:100%',
                        options: {
                            type: 'datetime',
                            format: 'yyyy-MM-dd HH:mm:ss'
                        },
                        type: 'datePicker',
                        title: this.$t('deliveryNoticeConfirm.t6'), // 作业开始日期
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'scheduledStartDateEnd',
                        validators: {
                        },
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 3
                        },
                        style: 'width:100%',
                        options: {
                            type: 'datetime',
                            format: 'yyyy-MM-dd HH:mm:ss',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        change: (obj, val) => {
                            if (val) {
                                if (val.split(' ')[1].indexOf('00:00:00') > -1) {
                                    obj.value = `${val.split(' ')[0]} 23:59:59`;
                                }
                            }
                        },
                        type: 'datePicker',
                        title: ''
                    }
                ]
            },
            columns: {
                columns: [
                    {
                        title: this.$t('createDeliveryOrderByOrder.t12'), // 物料编码
                        key: 'itemCode',
                        align: 'center',
                        sortable: true,
                        width: 150
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t13'), // 物料描述
                        key: 'itemName',
                        width: 300,
                        tooltip: true
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t13'), // 单位
                        key: 'primaryUomCode',
                        align: 'center',
                        width: 60
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t14'), // 要求数量
                        key: 'releasedQuantity',
                        width: 70,
                        align: 'right'
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t16'), // 作业开始时间
                        key: 'scheduledStartDate',
                        width: 130
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t17'), // 要求时间
                        key: 'needByDate',
                        width: 130,
                        align: 'center'
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t19'), // 承诺时间,
                        key: 'promisedDate',
                        width: 150,
                        align: 'center'
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t33'), // 拒绝原因
                        key: 'rejectReason',
                        width: 150,
                        align: 'center'
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t20'), // 买方
                        key: 'organizationName',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t21'), // 厂区
                        key: 'locationCode',
                        width: 150,
                        align: 'center',
                        tooltip: true
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t10'), // 子库
                        key: 'subInventory',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t15'), // 作业号
                        key: 'wipentityNames',
                        width: 120,
                        tooltip: true
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t18'), // 生产线
                        key: 'planLineDesc',
                        width: 120,
                        align: 'center',
                        tooltip: true
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t46'), // 状态
                        key: 'notifyStatusName',
                        width: 100,
                        align: 'center',
                        tooltip: true
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t23'), // 作业状态
                        key: 'meaning',
                        width: 100,
                        align: 'center'
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t24'), // 通知下达时间
                        key: 'releasedDate',
                        width: 125,
                        align: 'center'
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t25'), // 备货方式
                        key: 'feedType',
                        width: 100,
                        align: 'center'
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t26'), // 通知类型
                        key: 'sourceTypeMeaning',
                        width: 100,
                        align: 'center'
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t27'), // 通知号
                        key: 'notifyNumber',
                        width: 120,
                        align: 'center'
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t28'), // 订单号
                        key: 'poNumber',
                        width: 120,
                        align: 'center'
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t29'), // 订单行号
                        key: 'poLineNumber',
                        width: 50,
                        align: 'center'
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t30'), // 项目号
                        key: 'projectNumber',
                        width: 100,
                        align: 'center'
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t31'), // 说明
                        key: 'comments',
                        width: 100,
                        align: 'center'
                    }
                ]
            },
            tableData: [],
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: null,
                submitLoading: false
            }
        }
    },
    methods: {
        onSubmit (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageSizeChange (currentPage, pageSize) {
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        onSearch () {
            this.loading = true;
            axios.post('/gscint/order/queryNotify', {
                ...this.getFormDataVModel(this.formData.items),
                vendorCode: this.vendorCode,
                pageIndex: this.settings.currentPage,
                pageSize: this.settings.pageSize,
                language: this.$i18n.locale
            })
            .then((res) => {
                this.selection = [];
                this.loading = false;
                let data = res.data.data;
                if (data.code === '1') {
                    this.tableData = data.datas.list;
                    this.settings.total = data.datas.total;
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        exportExcel () {
            if (this.$refs.pageForm.$refs.queryForm.validateForm()) {
                this.loading = true;
                window.open(`/gscint/order/exportNotify?paraJson=${encodeURI(JSON.stringify(
                    {
                        ...this.getFormDataVModel(this.formData.items),
                        vendorCode: this.vendorCode
                    }
                ))}`);
                setTimeout(() => {
                    this.loading = false;
                }, 5000);
            }
        }
    },
    mounted () {
        this.getSRMInvLovListNew((data) => {
            let list = [];
            data.forEach((item) => {
                list.push({
                    label: item.organizationName,
                    value: item.organizationCode
                });
            });
            this.getFormDataItemObj(this.formData.items, 'orgCode').options.values = list;
        });
        this.getDict('INT_PM_FD_DEL_NOTIFY_STATUS', (data) => {
            this.getFormDataItemObj(this.formData.items, 'notifyNameStatus').options.values = data;
        });
        this.getDict('INT_PM_FD_FEED_TYPES', (data) => {
            this.getFormDataItemObj(this.formData.items, 'sourceTypeCode').options.values = data;
        });
    }
}
</script>